import { Theme } from '@mui/material/styles'

export const useStyle = {
  bold: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
  },

  details: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    maxHeight: '40px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },

  discountHeading: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    color: (theme: Theme) => theme.palette.text.primary,
    margin: '0',
    textOverflow: 'ellipsis',
  },

  discountTitle: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    color: (theme: Theme) => theme.palette.text.primary,
  },

  label: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    color: (theme: Theme) => theme.palette.text.primary,
  },

  priceTag: {
    margin: '0 6px',
  },

  viewFullDetailsLink: {
    color: '#1565c0',
    display: 'block',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    fontFamily: 'Source Sans Pro,sans-serif',
  },

  inputText: {
    width: '30px',
  },
}
